/**
 * Web Vitals reporter — captures FCP, LCP, CLS, INP, TTFB once per page
 * load and logs them. Page-scoped (not per-route) so we never double-count.
 *
 * Pure additive: no UI surface, no network request unless an explicit
 * endpoint is wired later. We sanitize the URL (path only) to avoid
 * leaking query-string tokens through any future transport.
 */

import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { logger } from '@/utils/logger';

let initialized = false;

export const initWebVitals = () => {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  const path =
    typeof location !== 'undefined' ? location.pathname : '/';

  const report = (metric: Metric) => {
    try {
      logger.info(`[web-vitals] ${metric.name}`, {
        value: Math.round(metric.value),
        rating: metric.rating,
        id: metric.id,
        path,
      });
    } catch {
      /* never throw from observability */
    }
  };

  try {
    onCLS(report);
    onFCP(report);
    onLCP(report);
    onINP(report);
    onTTFB(report);
  } catch {
    /* unsupported browser — silently skip */
  }
};
